import { styled } from '@zenbusiness/zui/styles';

const AlertStyle = ({ theme }) => ({
  padding: '16px 24px',
  borderRadius: '16px',
  backgroundColor: `${theme.palette.background.grey.light}`,
  border: `1px solid ${theme.palette.border.main}`
});

export const AlertStyled = styled('div')(AlertStyle);
